/**
 * Archive Header - Scroll Detection
 * Adds 'scrolled' class to header when user scrolls past 50px
 */

(function() {
  'use strict';

  // Get the header element
  const header = document.querySelector('.section-header');

  if (!header) return;

  let scrolled = false;
  const scrollThreshold = 50;

  // Throttle function to improve performance
  function throttle(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Handle scroll event
  function handleScroll() {
    const shouldBeScrolled = window.scrollY > scrollThreshold;

    if (shouldBeScrolled !== scrolled) {
      scrolled = shouldBeScrolled;

      if (scrolled) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
  }

  // Add scroll event listener with throttle
  window.addEventListener('scroll', throttle(handleScroll, 50));

  // Check on load
  handleScroll();
})();
